import { RiskKeys, RISK_GROUPS } from '@/config';
import { RiskType } from '@/models';

export default function getRiskGroupBySignal(signal: RiskKeys): RiskType | '' {
  const group = Object.keys(RISK_GROUPS).find((key) =>
    RISK_GROUPS[key as RiskType].includes(signal),
  );

  if (group) {
    return group as RiskType;
  }

  return '';
}
